import { useState, useCallback } from 'react';
import { NotificationMessage, NotificationSeverity } from '../components/common/NotificationSnackbar';

export const useNotification = () => {
  const [notification, setNotification] = useState<NotificationMessage | null>(null);

  const showNotification = useCallback((
    severity: NotificationSeverity,
    message: string,
    title?: string,
    duration?: number
  ) => {
    const id = Date.now().toString();
    setNotification({
      id,
      severity,
      message,
      title,
      duration,
    });
  }, []);

  const showSuccess = useCallback((message: string, title?: string) => {
    showNotification('success', message, title || '成功');
  }, [showNotification]);

  const showError = useCallback((message: string, title?: string) => {
    showNotification('error', message, title || 'エラー');
  }, [showNotification]);

  const showWarning = useCallback((message: string, title?: string) => {
    showNotification('warning', message, title || '警告');
  }, [showNotification]);

  const showInfo = useCallback((message: string, title?: string) => {
    showNotification('info', message, title || '情報');
  }, [showNotification]);

  const hideNotification = useCallback(() => {
    setNotification(null);
  }, []);

  return {
    notification,
    showNotification,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    hideNotification,
  };
};